import usePermission from "./usePermission";
import G from './Getters';
import { useStore } from 'react-redux';

function PermissionGate({
  fallback,
  req,
  children
}){

  const permission = usePermission(req)

  if( !permission ){

    return <div>Loading...</div>

  }else if( permission.data ){

    return children;


  }else{

    return null && (
      <div>
      <div>Not allowed!</div>
        {JSON.stringify(permission)}
      </div>
    )
  }


}

export default function PermissionGateWrapper({
  fallback,
  req,
  children,
  
}){

  const store = useStore();
  const state = store.getState();


  if( G.isInTutorial(state) ){
    return children;
  }

  return <PermissionGate {...{
    fallback,req,children
  }}/>



  






}
